// frontend/src/contexts/ActionIDManager.ts
import { Socket as ClientSocket } from "socket.io-client";

export default class ActionIDManager {
  static async getNext(socket: typeof ClientSocket): Promise<number> {
    return new Promise<number>((resolve) => {
      socket.once("response:actionId", (id: number) => resolve(id));
      socket.emit("request:actionId");
    });
  }
}
